import React from 'react';

import { IFormat } from '../../../../../../store/admin/roundFormats/store';
import FormatOption from './FormatOption';

interface IGameFormatSelectorSection {
  type: string;
  options: IFormat[];
  addFormat: (formatId: number) => () => Promise<void>;
}

export const GameFormatSelectorSection = (props: IGameFormatSelectorSection) => {
  const { type, addFormat, options } = props;

  return (
    <>
      <p>{type}:</p>

      <ul className="unselected-round-formats">
        {options.length > 0 ? (
          options.map((format, index) => (
            <FormatOption
              addFormat={addFormat}
              format={format}
              key={`unselected-round-format-${index}`}
            />
          ))
        ) : (
          <div className="empty-format-list">No {`${type.toLowerCase()}s`} available</div>
        )}
      </ul>
    </>
  );
};
